/* ARABELLE – theme.js (vanilla, fără dependențe) */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const cfg = window.arabelle || { routes: {}, strings: {} };
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Utils ---------- */
  const formatMoney = (cents) => {
    const fmt = cfg.moneyFormat || '{{amount}} lei';
    const amount = (cents / 100).toFixed(2);
    const [int, dec] = amount.split('.');
    const intFmt = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    let out = fmt;
    out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intFmt);
    out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, `${intFmt},${dec}`);
    out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Number(int).toLocaleString('ro-RO'));
    out = out.replace(/\{\{\s*amount\s*\}\}/g, `${Number(int).toLocaleString('ro-RO')},${dec}`);
    return out.replace(/<[^>]+>/g, '');
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  let toastEl, toastTimer;
  const toast = (msg, type = 'ok') => {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    const icon = type === 'error'
      ? '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/></svg>'
      : '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg>';
    toastEl.className = 'toast' + (type === 'error' ? ' toast--error' : '');
    toastEl.innerHTML = icon + '<span>' + msg + '</span>';
    clearTimeout(toastTimer);
    requestAnimationFrame(() => toastEl.classList.add('is-visible'));
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 3200);
  };

  /* ---------- Reveal on scroll ---------- */
  const initReveal = (root = document) => {
    const els = $$('.reveal:not(.is-visible)', root);
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px 0px 0px', threshold: 0.01 });
    els.forEach(e => io.observe(e));
    setTimeout(() => els.forEach(e => { if (!e.classList.contains('is-visible') && e.getBoundingClientRect().top < window.innerHeight * 1.1) e.classList.add('is-visible'); }), 1200);
  };

  /* ---------- Focus trap + drawers ---------- */
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';
  let lastFocused = null;
  const trapFocus = (container) => {
    const handler = (e) => {
      if (e.key !== 'Tab') return;
      const f = $$(FOCUSABLE, container).filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', handler);
    container._untrap = () => container.removeEventListener('keydown', handler);
  };
  const openOverlay = (el, panelSel) => {
    if (!el || el.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    const panel = $(panelSel, el) || el;
    trapFocus(panel);
    setTimeout(() => { const f = $('[data-autofocus]', panel) || $(FOCUSABLE, panel) || panel; f.focus({ preventScroll: true }); }, 60);
  };
  const closeOverlay = (el) => {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-modal.is-open')) document.body.classList.remove('drawer-open');
    const panel = $('.drawer__panel, .search-modal__panel', el) || el;
    if (panel._untrap) panel._untrap();
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  };
  const closeAll = () => $$('.drawer.is-open, .search-modal.is-open').forEach(closeOverlay);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeAll(); closeMega(); } });
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-drawer-close], [data-search-close]');
    if (closeBtn) { const ov = closeBtn.closest('.drawer, .search-modal'); if (ov) closeOverlay(ov); }
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openOverlay($(opener.getAttribute('data-drawer-open')), '.drawer__panel'); }
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  const initHeader = () => {
    if (!header) return;
    let lastY = window.scrollY, ticking = false;
    const transparent = header.classList.contains('site-header--transparent');
    const onScroll = () => {
      const y = window.scrollY;
      if (transparent) header.classList.toggle('is-solid', y > 40);
      if (y > 160 && y > lastY + 6 && !$('.nav__item.is-open')) header.classList.add('is-hidden');
      else if (y < lastY - 6 || y < 80) header.classList.remove('is-hidden');
      document.body.classList.toggle('header-hidden', header.classList.contains('is-hidden'));
      lastY = y; ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
    onScroll();
    const setOffset = () => document.documentElement.style.setProperty('--header-offset', header.offsetHeight + 'px');
    setOffset(); window.addEventListener('resize', debounce(setOffset, 150));
  };
  /* Mega menu */
  const closeMega = () => $$('.nav__item.is-open').forEach(i => { i.classList.remove('is-open'); const b = $('[aria-expanded]', i); if (b) b.setAttribute('aria-expanded', 'false'); });
  const initMega = () => {
    $$('.nav__item--has-children').forEach(item => {
      const link = $('.nav__link', item);
      let timer;
      item.addEventListener('mouseenter', () => { clearTimeout(timer); closeMega(); item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); });
      item.addEventListener('mouseleave', () => { timer = setTimeout(() => { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); }, 120); });
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches || e.detail === 0) {
          e.preventDefault();
          const open = item.classList.contains('is-open');
          closeMega();
          if (!open) { item.classList.add('is-open'); link.setAttribute('aria-expanded', 'true'); }
        }
      });
    });
    document.addEventListener('click', (e) => { if (!e.target.closest('.nav__item')) closeMega(); });
  };
  /* Mobile menu accordions */
  const initMobileNav = () => {
    $$('[data-mobile-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        const li = btn.closest('li');
        const open = li.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        const sub = $('.mobile-nav__sub', li);
        if (sub) sub.hidden = !open;
      });
    });
  };

  /* ---------- Announcement marquee ---------- */
  const initAnnouncement = () => {
    const bar = $('.announcement--marquee .announcement__track');
    if (!bar || bar.dataset.dup) return;
    const clone = Array.from(bar.children).map(c => { const n = c.cloneNode(true); n.classList.add('is-dup'); n.setAttribute('aria-hidden', 'true'); return n; });
    clone.forEach(n => bar.appendChild(n)); bar.dataset.dup = '1';
  };

  /* ---------- Search modal + predictive ---------- */
  const initSearch = () => {
    const modal = $('[data-search-modal]');
    if (!modal) return;
    const input = $('[data-search-input]', modal);
    const results = $('[data-search-results]', modal);
    $$('[data-search-open]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); openOverlay(modal, '.search-modal__panel'); setTimeout(() => input.focus(), 80); }));
    let ctrl;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; modal.classList.remove('has-results'); return; }
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      try {
        const url = `${cfg.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
        const res = await fetch(url, { signal: ctrl.signal });
        const html = await res.text();
        const doc = parseHTML(html);
        const inner = $('#shopify-section-predictive-search', doc) || doc.body;
        results.innerHTML = inner.innerHTML;
        modal.classList.add('has-results');
      } catch (err) { if (err.name !== 'AbortError') console.warn(err); }
    }, 220);
    input.addEventListener('input', run);
    input.addEventListener('keydown', (e) => {
      const items = $$('.search-result', results);
      if (!items.length) return;
      const idx = items.findIndex(i => i.classList.contains('is-active'));
      if (e.key === 'ArrowDown') { e.preventDefault(); items.forEach(i => i.classList.remove('is-active')); items[(idx + 1) % items.length].classList.add('is-active'); }
      if (e.key === 'ArrowUp') { e.preventDefault(); items.forEach(i => i.classList.remove('is-active')); items[(idx - 1 + items.length) % items.length].classList.add('is-active'); }
      if (e.key === 'Enter' && idx >= 0) { e.preventDefault(); window.location.href = items[idx].href; }
    });
  };

  /* ---------- Cart ---------- */
  const cartDrawer = $('[data-cart-drawer]');
  const updateCartCount = (count) => $$('[data-cart-count]').forEach(el => { el.textContent = count; el.setAttribute('data-count', count); });
  const refreshCart = async (openDrawer = false) => {
    const sections = ['cart-drawer'];
    const mainCart = $('[data-main-cart]');
    if (mainCart) sections.push(mainCart.dataset.sectionId);
    try {
      const res = await fetch(`${cfg.routes.cart}?sections=${sections.join(',')}&t=${Date.now()}`);
      const data = await res.json();
      if (cartDrawer && data['cart-drawer']) {
        const doc = parseHTML(data['cart-drawer']);
        const fresh = $('[data-cart-drawer]', doc);
        if (fresh) {
          const wasOpen = cartDrawer.classList.contains('is-open');
          const body = $('[data-cart-drawer-body]', cartDrawer); const freshBody = $('[data-cart-drawer-body]', fresh);
          if (body && freshBody) body.innerHTML = freshBody.innerHTML;
          const foot = $('.drawer__footer', cartDrawer); const freshFoot = $('.drawer__footer', fresh);
          if (foot && freshFoot) foot.innerHTML = freshFoot.innerHTML;
          else if (foot && !freshFoot) foot.remove();
          else if (!foot && freshFoot) $('.drawer__panel', cartDrawer).appendChild(freshFoot);
          const cnt = $('.drawer__count', cartDrawer); const freshCnt = $('.drawer__count', fresh);
          if (cnt && freshCnt) cnt.textContent = freshCnt.textContent;
          if (wasOpen) cartDrawer.classList.add('is-open');
        }
      }
      if (mainCart && data[mainCart.dataset.sectionId]) {
        const doc = parseHTML(data[mainCart.dataset.sectionId]);
        const fresh = $('[data-main-cart]', doc);
        if (fresh) mainCart.innerHTML = fresh.innerHTML;
      }
      const cartRes = await fetch(`${cfg.routes.cart}.js`); const cart = await cartRes.json();
      updateCartCount(cart.item_count);
      if (openDrawer && cartDrawer) openOverlay(cartDrawer, '.drawer__panel');
      initReveal();
    } catch (e) { console.warn(e); }
  };
  window.ArabelleRefreshCart = refreshCart;
  window.ArabelleFormatMoney = formatMoney;
  const addToCart = async (items, btn) => {
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    try {
      const res = await fetch(cfg.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || cfg.strings.error);
      if (cartDrawer) await refreshCart(true); else { await refreshCart(false); toast(cfg.strings.added); }
    } catch (err) { toast(err.message || cfg.strings.error, 'error'); }
    finally { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } }
  };
  const changeLine = async (line, quantity, el) => {
    if (el) el.classList.add('is-loading');
    try {
      const res = await fetch(cfg.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!res.ok) throw new Error();
      await refreshCart(false);
    } catch (e) { toast(cfg.strings.error, 'error'); if (el) el.classList.remove('is-loading'); }
  };
  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && cartDrawer) { e.preventDefault(); openOverlay(cartDrawer, '.drawer__panel'); return; }
    const quick = e.target.closest('[data-quick-add]');
    if (quick) { e.preventDefault(); addToCart([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], quick); return; }
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) { const item = rm.closest('[data-cart-item]'); changeLine(Number(item.dataset.line), 0, item); return; }
    const minus = e.target.closest('[data-qty-minus]'), plus = e.target.closest('[data-qty-plus]');
    if (minus || plus) {
      const wrap = (minus || plus).closest('[data-qty]'); const input = $('[data-qty-input]', wrap);
      const min = Number(input.min || 0); let v = Number(input.value) + (plus ? 1 : -1); if (v < min) v = min;
      input.value = v;
      const item = wrap.closest('[data-cart-item]');
      if (item) changeLine(Number(item.dataset.line), v, item);
      else input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-item] [data-qty-input]');
    if (input) { const item = input.closest('[data-cart-item]'); changeLine(Number(item.dataset.line), Math.max(0, Number(input.value)), item); }
  });
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    const id = Number(fd.get('id')); const qty = Number(fd.get('quantity') || 1);
    const items = [{ id, quantity: qty }];
    const props = {};
    fd.forEach((v, k) => { const m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    if (Object.keys(props).length) items[0].properties = props;
    const sample = $('[data-sample-variant]', form);
    if (sample && sample.checked) items.push({ id: Number(sample.dataset.sampleVariant), quantity: 1 });
    addToCart(items, $('[type=submit]', form));
  });
  /* LP: butoanele secundare „Adaugă în coș” trimit formularul principal */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-lp-add]');
    if (!b) return;
    const atc = $('[data-product-form] [data-atc]');
    if (atc && !atc.disabled) atc.click();
  });
  /* Cart page note */
  document.addEventListener('change', debounce((e) => {
    const note = e.target.closest('[data-cart-note]');
    if (note) fetch(cfg.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  }, 400));

  /* ---------- Product page ---------- */
  const initProduct = () => {
    const root = $('[data-product]');
    if (!root) return;
    const variants = JSON.parse($('[data-variants-json]', root).textContent);
    const form = $('[data-product-form]', root);
    const idInput = $('input[name=id]', form);
    const priceEl = $('[data-product-price]', root);
    const compareEl = $('[data-product-compare]', root);
    const atc = $('[data-atc]', form);
    const atcText = $('[data-atc-text]', atc);
    const stockEl = $('[data-stock]', root);
    const stickyPrice = $('[data-sticky-price]');
    const selectedLabels = $$('[data-selected-value]', root);
    const getSelected = () => $$('.variant-picker', root).map(p => { const c = $('input:checked', p); return c ? c.value : null; });
    const findVariant = () => { const sel = getSelected(); return variants.find(v => v.options.every((o, i) => o === sel[i])); };
    const update = () => {
      const v = findVariant();
      selectedLabels.forEach((el, i) => { const sel = getSelected(); el.textContent = sel[i] || ''; });
      if (!v) { atc.disabled = true; atcText.textContent = cfg.strings.unavailable; return; }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (v.available) { atc.disabled = false; atcText.textContent = cfg.strings.addToCart; }
      else { atc.disabled = true; atcText.textContent = cfg.strings.soldOut; }
      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!v.available) { stockEl.textContent = 'Stoc epuizat'; stockEl.classList.add('is-out'); }
        else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) { stockEl.textContent = `Doar ${v.inventory_quantity} bucăți în stoc`; stockEl.classList.add('is-low'); }
        else stockEl.textContent = 'În stoc, livrare în 1–3 zile lucrătoare';
      }
      // mark unavailable chips for the other options
      $$('.variant-picker', root).forEach((picker, pi) => {
        $$('.variant-chip', picker).forEach(chip => {
          const val = $('input', chip).value; const sel = getSelected(); sel[pi] = val;
          const match = variants.find(x => x.options.every((o, i) => o === sel[i]));
          chip.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (v.featured_media && window.arabelleGallery) window.arabelleGallery.goToMedia(v.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    };
    $$('.variant-picker input', root).forEach(i => i.addEventListener('change', update));
    update();

    /* Gallery */
    const gallery = $('[data-gallery]', root);
    if (gallery) {
      const track = $('.gallery__track', gallery); const slides = $$('.gallery__slide', gallery);
      const thumbs = $$('.gallery__thumb', gallery); const dots = $$('.gallery__dot', gallery);
      const setActive = (i) => { thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
      const goTo = (i) => { track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(i); };
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
      track.addEventListener('scroll', debounce(() => { const i = Math.round(track.scrollLeft / track.clientWidth); setActive(i); }, 80), { passive: true });
      window.arabelleGallery = { goToMedia: (id) => { const i = slides.findIndex(s => Number(s.dataset.mediaId) === id); if (i >= 0) goTo(i); } };
    }
    /* Sticky ATC (mobile) */
    const sticky = $('[data-sticky-atc]');
    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 });
      io.observe(atc);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); });
    }
    /* Qty on product */
    const qtyInput = $('[data-qty-input]', form);
    if (qtyInput) qtyInput.addEventListener('change', () => { if (Number(qtyInput.value) < 1) qtyInput.value = 1; });
  };

  /* ---------- Collection filters ---------- */
  const initCollection = () => {
    const root = $('[data-collection]');
    if (!root) return;
    const sectionId = root.dataset.sectionId;
    const grid = $('[data-collection-grid]', root);
    const forms = $$('[data-filter-form]');
    const sort = $('[data-sort]', root);
    let ctrl;
    const render = async (url, push = true) => {
      grid.classList.add('is-loading');
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      try {
        const u = new URL(url, window.location.origin); u.searchParams.set('section_id', sectionId);
        const res = await fetch(u.toString(), { signal: ctrl.signal });
        const doc = parseHTML(await res.text());
        const fresh = $('[data-collection]', doc);
        ['[data-collection-grid]', '[data-collection-count]', '[data-active-filters]', '[data-pagination]', '[data-chip-bar]'].forEach(sel => {
          const a = $(sel, root), b = $(sel, fresh); if (a && b) a.innerHTML = b.innerHTML;
        });
        // refresh filter counts in all filter forms (desktop + drawer)
        const freshFilters = $('[data-filters-inner]', fresh);
        if (freshFilters) $$('[data-filters-inner]').forEach(f => { f.innerHTML = freshFilters.innerHTML; });
        if (push) history.pushState({}, '', url);
        grid.classList.remove('is-loading');
        initReveal(root);
        const top = root.getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      } catch (e) { if (e.name !== 'AbortError') { grid.classList.remove('is-loading'); window.location.assign(url); } }
    };
    const buildUrl = (form) => {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      fd.forEach((v, k) => { if (v !== '') params.append(k, v); });
      if (sort && sort.value) params.set('sort_by', sort.value);
      const base = window.location.pathname;
      const s = params.toString();
      return base + (s ? '?' + s : '');
    };
    const onChange = debounce((e) => { const form = e.target.closest('[data-filter-form]'); if (form) render(buildUrl(form)); }, 250);
    forms.forEach(f => { f.addEventListener('change', onChange); f.addEventListener('submit', (e) => { e.preventDefault(); render(buildUrl(f)); }); });
    if (sort) sort.addEventListener('change', () => { const u = new URL(window.location.href); u.searchParams.set('sort_by', sort.value); render(u.pathname + u.search); });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-active-filters] a, [data-filter-link]');
      if (a && root.contains(a)) { e.preventDefault(); render(a.getAttribute('href')); }
    });
    window.addEventListener('popstate', () => render(window.location.href, false));
    // sync forms: when drawer form changes, copy to desktop form and vice versa handled by full re-render of inner
  };

  /* ---------- Search page tabs ---------- */
  const initSearchTabs = () => {
    const tabs = $$('.search-tabs button');
    if (!tabs.length) return;
    tabs.forEach(t => t.addEventListener('click', () => {
      tabs.forEach(x => x.setAttribute('aria-selected', x === t ? 'true' : 'false'));
      $$('.search-page__panel').forEach(p => p.hidden = p.id !== t.getAttribute('aria-controls'));
    }));
  };

  /* ---------- Address form toggle (account) ---------- */
  const initAddresses = () => {
    $$('[data-address-toggle]').forEach(b => b.addEventListener('click', () => {
      const target = $(b.getAttribute('data-address-toggle')); if (target) { target.hidden = !target.hidden; if (!target.hidden) $('input', target)?.focus(); }
    }));
    $$('[data-address-delete]').forEach(b => b.addEventListener('click', () => {
      if (!confirm('Ștergi această adresă?')) return;
      const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.addressDelete;
      f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit();
    }));
    if (window.Shopify && Shopify.CustomerAddress) {
      $$('[data-address-country]').forEach(sel => new Shopify.CountryProvinceSelector(sel.id, sel.dataset.addressCountry, { hideElement: sel.dataset.addressCountry + '_container' }));
    }
  };


  /* ---------- Return form stepper ---------- */
  const initReturnForm = () => {
    const form = document.getElementById('ReturnForm'); if (!form) return;
    const steps = $$('[data-step]', form); const dots = $$('[data-step-dot]', form);
    let current = 1;
    const show = (n) => {
      current = n;
      steps.forEach(s => s.classList.toggle('is-active', Number(s.dataset.step) === n));
      dots.forEach(d => { const k = Number(d.dataset.stepDot); d.classList.toggle('is-active', k === n); d.classList.toggle('is-done', k < n); });
      const top = form.getBoundingClientRect().top + window.scrollY - 120; window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    const valid = (n) => {
      const step = steps[n - 1]; let ok = true;
      $$('input,select,textarea', step).forEach(el => { if (ok && !el.checkValidity()) { ok = false; el.reportValidity(); } });
      return ok;
    };
    form.addEventListener('click', (e) => {
      if (e.target.closest('[data-step-next]')) { e.preventDefault(); if (valid(current)) show(Math.min(current + 1, steps.length)); }
      if (e.target.closest('[data-step-prev]')) { e.preventDefault(); show(Math.max(current - 1, 1)); }
    });
    form.addEventListener('submit', (e) => { for (let i = 1; i <= steps.length; i++) { if (!valid(i)) { e.preventDefault(); show(i); return; } } });
    /* popup: citește politica de retur */
    const modal = $('[data-policy-modal]');
    if (modal) {
      let seen = false; try { seen = sessionStorage.getItem('arabelle_return_policy_ok') === '1'; } catch (e) {}
      if (!seen) {
        modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); document.body.classList.add('drawer-open');
        setTimeout(() => { const b = $('[data-policy-modal-close]', modal); if (b) b.focus(); }, 80);
      }
      $$('[data-policy-modal-close]', modal).forEach(b => b.addEventListener('click', () => {
        modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('drawer-open');
        try { sessionStorage.setItem('arabelle_return_policy_ok', '1'); } catch (e) {}
      }));
    }
  };

  /* Footer: acordeoane închise pe mobil */
  const initFooterAcc = () => {
    const mq = window.matchMedia('(max-width: 767px)');
    const apply = () => $$('[data-footer-acc]').forEach(d => { d.open = !mq.matches; });
    apply(); mq.addEventListener('change', apply);
  };

  /* Ora locală în footer + secvența hero */
  const initEditorial = () => {
    const el = $('[data-local-time]');
    if (el) { const tick = () => { el.textContent = new Date().toLocaleTimeString('ro-RO', { timeZone: 'Europe/Bucharest', hour: '2-digit', minute: '2-digit' }); }; tick(); setInterval(tick, 30000); }
    const hero = $('[data-ed-hero]');
    if (hero) requestAnimationFrame(() => requestAnimationFrame(() => hero.classList.add('is-in')));
  };

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    initReveal(); initHeader(); initMega(); initMobileNav(); initAnnouncement(); initSearch();
    initProduct(); initCollection(); initSearchTabs(); initAddresses(); initReturnForm(); initFooterAcc();
    fetch(`${cfg.routes.cart}.js`).then(r => r.json()).then(c => updateCartCount(c.item_count)).catch(() => {});
  });
  document.addEventListener('shopify:section:load', (e) => { initReveal(e.target); initMega(); initMobileNav(); });
  document.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector('[data-cart-drawer]')) openOverlay(cartDrawer, '.drawer__panel'); });
  document.addEventListener('shopify:section:deselect', (e) => { if (e.target.querySelector('[data-cart-drawer]')) closeOverlay(cartDrawer); });
})();

  /* video principal din galerie: porneste automat (mut), se opreste cand iese din ecran */
  function initAutoVideo() {
    document.querySelectorAll('video.gallery__video--auto').forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      var tryPlay = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      tryPlay();
      document.addEventListener('visibilitychange', function () { if (!document.hidden) tryPlay(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) tryPlay(); else v.pause(); }); }, { threshold: .2 }).observe(v);
      var sb = v.parentElement && v.parentElement.querySelector('[data-sound]');
      if (sb) {
        var label = sb.querySelector('span');
        var setLbl = function () { var on = !v.muted; sb.setAttribute('aria-pressed', on ? 'true' : 'false'); sb.classList.toggle('is-on', on); if (label) label.textContent = on ? 'Oprește sunetul' : 'Pornește sunetul'; };
        sb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); v.muted = !v.muted; if (!v.muted) { v.volume = 1; tryPlay(); } setLbl(); });
        v.addEventListener('click', function () { if (v.muted) { v.muted = false; v.volume = 1; tryPlay(); setLbl(); } });
        setLbl();
      }
    });
  }
  initAutoVideo();
  /* ---------- Order bump: bifat = produsul intră în coșul Shopify (EasySell comandă produs + coș), debifat = iese ---------- */
  function initBumps() {
    var bumps = Array.prototype.slice.call(document.querySelectorAll('[data-lp-bump]'));
    if (!bumps.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var pending = 0, waiters = [];
    function settled() { return pending === 0; }
    function post(url, body) { return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); }
    function afterSettle() { waiters.splice(0).forEach(function (cb) { cb(); }); if (window.ArabelleRefreshCart) window.ArabelleRefreshCart(false); }
    bumps.forEach(function (bump) {
      var check = bump.querySelector('input');
      var vid = parseInt(bump.getAttribute('data-variant-id'), 10);
      var unit = parseInt(bump.getAttribute('data-unit'), 10) || 0;
      var qty = 1, qtyVal = bump.querySelector('[data-qty-val]'), total = bump.querySelector('[data-bump-total]');
      function paint() {
        bump.classList.toggle('is-on', check.checked);
        if (qtyVal) qtyVal.textContent = qty;
        if (total) total.textContent = '+' + (window.ArabelleFormatMoney ? window.ArabelleFormatMoney(unit * qty) : (unit * qty / 100).toFixed(2).replace('.', ',') + ' lei');
      }
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var it = (c.items || []).filter(function (i) { return i.variant_id === vid; })[0];
        if (it) { check.checked = true; qty = Math.max(1, it.quantity); paint(); }
      }).catch(function () {});
      bump.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (b) {
        b.addEventListener('click', function (ev) {
          ev.preventDefault(); ev.stopPropagation();
          qty = b.hasAttribute('data-qty-plus') ? Math.min(qty + 1, 10) : Math.max(qty - 1, 1);
          if (!check.checked) check.checked = true;
          paint(); syncCart();
        });
      });
      var syncing = false, again = false;
      function syncCart() {
        if (syncing) { again = true; return; }
        syncing = true; pending++;
        var want = check.checked ? qty : 0;
        var u = {}; u[vid] = 0;
        var chain = post('cart/update.js', { updates: u });
        if (want) chain = chain.then(function () { return post('cart/add.js', { items: [{ id: vid, quantity: want }] }); }).then(function (r) { if (!r.ok) throw new Error('add failed'); });
        chain.catch(function () { if (want && check.checked) { check.checked = false; paint(); } }).then(function () {
          syncing = false; pending--;
          if (again) { again = false; syncCart(); return; }
          if (settled()) afterSettle();
        });
      }
      check.addEventListener('change', function () { paint(); syncCart(); });
    });
    /* Gardă: „Comandă acum” (EasySell) și „Adaugă în coș” așteaptă sincronizarea coșului */
    document.addEventListener('click', function (ev) {
      var t = ev.target && ev.target.closest && ev.target.closest('.es-popup-button-product, .es-popup-button, [data-atc], [data-sticky-btn]');
      if (!t || settled()) return;
      ev.preventDefault(); ev.stopImmediatePropagation(); ev.stopPropagation();
      waiters.push(function () { t.click(); });
    }, true);
  }
  initBumps();

